import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	noMatchingResult: {
		id: 'users-and-roles.actors-table.table-filter-empty-view.no-matching-result',
		defaultMessage: 'We couldn’t find anyone matching your search',
		description: 'Text displayed in table when there are no matching results after filtering.',
	},
	changeFilter: {
		id: 'users-and-roles.actors-table.table-filter-empty-view.change-filter',
		defaultMessage: 'Try a different name or double-check your filters.',
		description:
			'Text displayed in table when there are no matching results after filtering. ' +
			'Text describe that customer need to recheck filters which are applied ',
	},
});
